import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom } from '../../State';
import { useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';

export default function NoMetaMask({ setNoMetaMaskState }) {
  const callObject = useDaily();
  const setPageState = useSetRecoilState(pageAtom);

  //背景をタップ時
  const tapBack = () => {
    //setPageState('main');
    setNoMetaMaskState(false);
  };

  return (
    <>
      <div className="backWrap" onClick={tapBack}></div>
      <div id="noMetaMaskWrapWrap">
        <div id="nftTitle">
          Install MetaMask
          <div id="nftCloseButton">
            <CloseSVG onClick={tapBack} />
          </div>
        </div>

        <div id="noMetaMaskWrap">
          <div>You need to install MetaMask to login</div>
          <div>
            {' '}
            <img src="./images/header/metaMask.svg" />
          </div>
          <div>
            <a href="https://metamask.io/" target="_blank">
              Install Now
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
